import { render } from "./CtqRegistry.vue?vue&type=template&id=201cb4ea&scoped=true"
import script from "./CtqRegistry.js?vue&type=script&lang=js"
export * from "./CtqRegistry.js?vue&type=script&lang=js"

import "./CtqRegistry.vue?vue&type=style&index=0&id=201cb4ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201cb4ea"]])

export default __exports__